module.exports = __webpack_public_path__ + "static/media/football-carousel-2-800x1280.1443ebf6.jpg";